export let RefreshModeTypes = {
  Server: 'Server', // data is refreshed by the server, such as by scheduled refresh task
  Remote: 'Remote' // data is refreshed by an end-user's computer
};

// The datasource domain entity has been extended to have these properties for the sake of performing
// remote refreshes, aka Tableau Bridge.
export interface IRemoteRefreshProperties {
  refreshMode: string; // RefreshModeType
  remoteAgentName: string; // The computer that has the Tableau Bridge client installed and that will refresh this datasource
  remoteAgentTimeZone?: string; // The time zone of the Tableau Bridge client
  remoteAgentId: string; // The id of the Tableau Bridge client
  remoteRunNextAt: string; // The next time this datasource will be refreshed as ISO 8601 UTC: YYYY-MM-DDThh:mm:ssZ
  remoteAgentReservationId: string; // A unique ID that may be claimed by a remote agent to refresh this data source.
  remoteQueryAgentSiteDefault?: boolean; // If this agent is assigned as the site default to handle remote queries
  usingRemoteQueryAgent: boolean; // If this data source is being remoted for live connections.
}
